import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const NotificationOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2 4.29v-.95c0-.44.36-.8.8-.8.44 0 .8.36.8.8v.95a6.343 6.343 0 0 1 5.54 6.29v4.48c0 .26.08.51.23.72l1.08 1.56h.02c.21.24.33.54.33.85 0 .7-.57 1.27-1.27 1.27h-3.61a3.178 3.178 0 0 1-2.48 2.48c-1.72.34-3.39-.76-3.74-2.48H5.29c-.32 0-.62-.12-.85-.33-.52-.47-.56-1.27-.09-1.79l1.08-1.56c.15-.21.23-.46.23-.72v-4.48a6.343 6.343 0 0 1 5.54-6.29Zm-.66 15.17c.22.61.8 1.03 1.46 1.03.66 0 1.24-.41 1.46-1.03h-2.92Zm-4.78-1.74a.75.75 0 0 1-.07.08h12.6c-.03-.02-.07-.08-.07-.08l-1.04-1.5c-.28-.4-.43-.87-.43-1.36v-4.2c0-2.63-2.13-4.76-4.76-4.76s-4.76 2.13-4.76 4.76v4.2c0 .49-.15.96-.43 1.36l-1.04 1.5Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default NotificationOutlined
